/**
 * @namespace {BX.UI}
 */
export default class ButtonSize
{
	static LARGE = 'ui-btn-lg';
	static MEDIUM = 'ui-btn-md';
	static SMALL = 'ui-btn-sm';
	static EXTRA_SMALL = 'ui-btn-xs';
}